var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.categories
        ? _c("category-filter", {
            attrs: {
              "selected-category": _vm.selectedCategory,
              categories: _vm.categories
            },
            on: {
              "update-state": function($event) {
                return _vm.$emit("update-state", $event)
              },
              "get-campaigns": function($event) {
                return _vm.$emit("get-campaigns")
              }
            }
          })
        : _vm._e(),
      _c("product-type-filter", {
        attrs: {
          "selected-product-type": _vm.selectedProductType,
          "product-types": _vm.productTypes,
          categories: _vm.categories
        },
        on: {
          "update-state": function($event) {
            return _vm.$emit("update-state", $event)
          },
          "get-campaigns": function($event) {
            return _vm.$emit("get-campaigns")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }